import { render, staticRenderFns } from "./formOpen.vue?vue&type=template&id=b1e4e524&scoped=true&"
import script from "./formOpen.vue?vue&type=script&lang=js&"
export * from "./formOpen.vue?vue&type=script&lang=js&"
import style0 from "./formOpen.vue?vue&type=style&index=0&id=b1e4e524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e4e524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VIcon,VRadio,VRadioGroup,VTextField,VTextarea})
